import React, { type PropsWithChildren } from 'react';
import { Spotlight, SpotlightPulse, SpotlightTransition } from '@atlaskit/onboarding';
import { useIntl } from '@atlassian/jira-intl';
import { useFiltersMenuSpotlightOnboarding } from '../controllers/filters-menu-onboarding.tsx';
import messages from './FiltersMenuOnboarding.messages.tsx';

export const FiltersMenuOnboarding = ({ children }: PropsWithChildren): React.JSX.Element => {
	const [isOnboardingVisible, markAsSeen] = useFiltersMenuSpotlightOnboarding();
	const { formatMessage } = useIntl();
	return (
		<>
			<SpotlightPulse radius={3} pulse={isOnboardingVisible}>
				{children}
			</SpotlightPulse>
			{isOnboardingVisible && (
				<SpotlightTransition>
					<Spotlight
						actions={[
							{
								onClick: markAsSeen,
								text: formatMessage(messages.spotlightDismissButton),
							},
						]}
						heading={formatMessage(messages.spotlightTitle)}
						target="jira-nin-saved-filters-popup-content"
						targetRadius={3}
						dialogWidth={275}
						pulse={false}
						dialogPlacement="left top"
					>
						{formatMessage(messages.spotlightBody)}
					</Spotlight>
				</SpotlightTransition>
			)}
		</>
	);
};
